import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LoaderBar } from '../components/LoaderBar';
import { UserService } from '../utility/services/user';
import { handoffFailedRecently } from './sso.helpers.js';
import { unifiedLoginTarget } from './unified-login.helpers.js';

/**
 * Wraps the warehouse login and forgot-password screens. With the unified-login build flag on,
 * it sends the browser to the customer login page on the portal domain; otherwise (and for a
 * signed-in user or after a failed /sso handoff) it renders the screen as before.
 */
export function UnifiedLoginRedirect({ page, children }) {
  const { state } = useLocation();
  const target = unifiedLoginTarget({
    env: {
      VITE_UNIFIED_LOGIN: import.meta.env.VITE_UNIFIED_LOGIN,
      VITE_PORTAL_URL: import.meta.env.VITE_PORTAL_URL,
    },
    page,
    redirectUrl: state?.query?.redirectUrl,
    authenticated: UserService.isAuthenticated(),
    // The router state is lost on reload; the session marker keeps the page from bouncing then.
    handoffFailed:
      typeof state?.message === 'string' || handoffFailedRecently(window.sessionStorage),
  });

  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);

  return target ? <LoaderBar /> : children;
}
